var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-chip',{attrs:{"color":_vm.active ? 'success' : 'error',"text-color":"white","label":"","small":""},on:{"click":function($event){return _vm.toggle()}}},[_vm._v(" "+_vm._s(_vm.active ? "Active" : "Inactive")+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }